import exp from "constants";
import BurnedSavanna from "../assets/images/bees/burned_complex_savanna.jpg";
import ColletesHabitat from "../assets/images/bees/colletes_andrese_habitat.jpg";
import MesicHill from "../assets/images/bees/dry_mesic_gravel_hill.jpg";
import MesicPrairie from "../assets/images/bees/dry_mesic_prairie_dalea.jpg";
import RemnantPrairie from "../assets/images/bees/remnant-prairie.jpg";
import RemnantSavanna from "../assets/images/bees/remnant-savanna-august.jpg";

interface BeeHabitatsType {
  image: string;
  description: string;
}

const BeeHabitats: BeeHabitatsType[] = [
  {
    image: BurnedSavanna,
    description: "Regularly burned complex of dry-mesic savanna and prairie",
  },
  {
    image: ColletesHabitat,
    description:
      "Colletes andrewsi & C. aestivalis habitat. Remnant dry-mesic gravel hill prairie with abundant Heuchera richardsonii",
  },
  {
    image: MesicHill,
    description:
      "Dry-mesic gravel hill prairie with Echinacea pallida, the pollen host for Andrena helianthiformis",
  },
  {
    image: MesicPrairie,
    description:
      "Dry-mesic prairie with Dalea purpurea, a pollen host for Colletes susannae and C. kincaidii",
  },
  {
    image: RemnantPrairie,
    description: "Remnant dry-mesic prairie",
  },
  {
    image: RemnantSavanna,
    description: "Remnant dry-mesic savanna in early August",
  },
];

export default BeeHabitats;
export type { BeeHabitatsType };
